import { useEffect, lazy, Suspense } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import HomePage from './pages/HomePage'
import ProtectedRoute from './components/ProtectedRoute'
import { initializeSession } from './services/analyticsService'

// Keep the landing page light: the studio (Gemini SDK, motion, icons, HEIC) and
// the admin (recharts) load on demand, not on first paint of "/".
const VisualizerPage = lazy(() => import('./pages/VisualizerPage'))
const AdminLoginPage = lazy(() => import('./pages/AdminLoginPage'))
const AdminDashboardPage = lazy(() => import('./pages/AdminDashboardPage'))

function RouteFallback() {
  return (
    <div style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', color: 'var(--ink-faint)' }}>
      Loading…
    </div>
  )
}

function App() {
  const location = useLocation()

  // Initialize analytics session once per tab (not per page)
  // Only for user-facing pages, not admin routes
  useEffect(() => {
    const isAdminRoute = location.pathname.startsWith('/admin')

    if (!isAdminRoute) {
      initializeSession()
    }
  }, []) // Empty deps = runs once on mount, regardless of navigation

  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/visualizer"
          element={
            <Suspense fallback={<RouteFallback />}>
              <VisualizerPage />
            </Suspense>
          }
        />
        <Route
          path="/admin/login"
          element={
            <Suspense fallback={<RouteFallback />}>
              <AdminLoginPage />
            </Suspense>
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <Suspense fallback={<RouteFallback />}>
                <AdminDashboardPage />
              </Suspense>
            </ProtectedRoute>
          }
        />
      </Routes>
      <Analytics />
    </div>
  )
}

export default App
